import { Colors } from "../../Colors";

export const PongColors = {
  LeftPaddleUp: Colors.Blue.C600,
  LeftPaddleDown: Colors.Blue.C900,
  RightPaddleUp: Colors.Red.C600,
  RightPaddleDown: Colors.Red.C900,
  Background: Colors.BlueGrey.C800,
  ClientBackground: Colors.BlueGrey.C400,
  Ball: Colors.Teal.C400,
  Score: Colors.BlueGrey.C500,
};
